interface IRawCourierRule {
  id: number;
}

export const isMutationSuccessful = (response: any) => 'data' in response && response.data?.state === 1;

export const getRuleChanges = <T extends IRawCourierRule>(rules: Array<T>, loadedRules: Array<T>, valueKey: keyof T) => {
  const added = rules.filter((rule) => rule.id < 0);
  const currentIds = rules.map((rule) => rule.id);
  const deletedIds = loadedRules.filter((loaded) => !currentIds.includes(loaded.id)).map((loaded) => loaded.id);
  const updated = rules.filter((rule) => {
    if (rule.id < 0) return false;
    const loaded = loadedRules.find((item) => item.id === rule.id);
    return !!loaded && loaded[valueKey] !== rule[valueKey];
  });
  return { added, deletedIds, updated, isDirty: added.length > 0 || deletedIds.length > 0 || updated.length > 0 };
};
